import React from 'react'

function HistoriqueTransaction({ transactions }) {
  return (
    <div className="historique-transactions">
      <h3>Historique des transactions</h3>
      <table>
        <thead>
          <tr>
            <th>Date</th>
            <th>Institution</th>
            <th>Montant</th>
            <th>Service</th>
          </tr>
        </thead>
        <tbody>
          {transactions.map((transaction, index) => (
            <tr key={index}>
              <td>{transaction.date}</td>
              <td>{transaction.institution}</td>
              <td>{transaction.montant} FCFA</td>
              <td>{transaction.service}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default HistoriqueTransaction